/**
 * Created by claudio iozzia on 11/07/2017.
 */
import {Validator_DcLED_Buck} from "./dcLED_buck_validator";
import {IAppSpec} from "../../../../Redux/selector.state";
import {Utils} from "../../../../common/utils";
import {Ic} from "../../../../models/common";
import {ValueFormatter} from "../../../../common/ValueFormatter";
import {siPrefix} from "../../../../common/siPrefix";
import {Range} from '../../../../common/Range';

export class Validator_DcLED_Boost extends Validator_DcLED_Buck {
  protected getVoutBounds(ic: Ic, spec: IAppSpec): Range {
    const _vin = spec.spec.value.input;
    const _vin_note = spec.spec.note.input;


    const isAttendibileVinMin: boolean = ! _vin_note.min.hasError && Utils.isValueReal( _vin.min );
    const isAttendibileVinMax: boolean = ! _vin_note.max.hasError && Utils.isValueReal( _vin.max );


    let vOutLowerBound: number;

    if (isAttendibileVinMax)
      vOutLowerBound = _vin.max;

    else if (isAttendibileVinMin)
      vOutLowerBound = _vin.min;

    else
      vOutLowerBound = ic.vout_min;

    if (vOutLowerBound < ic.vout_min)
      vOutLowerBound = ic.vout_min;

    vOutLowerBound = ValueFormatter.scale(vOutLowerBound, siPrefix.unit, 1, "c");

    // const vOutUpperBound:Number = ValueFormatter.scale(ic.vout_max, siPrefix.unit, 1, "f");
    return new Range(vOutLowerBound, ic.vout_max);
  }
}
